import { put } from 'redux-saga/effects';

import { configSlice } from '..';
import { getShortUrlId } from '../../../helpers/navigation';
import { getOneTimeValue, ONE_TIME_KEYS } from '../../../helpers/one-time-value';

/**
 *
 */
export function* checkCreatedWithReload() {
    const conferenceId = getShortUrlId();

    const idCreatedWithReload = getOneTimeValue(ONE_TIME_KEYS.ID_CREATED_WITH_RELOAD);
    const createdWithReload = idCreatedWithReload === conferenceId;

    if (!createdWithReload) {
        return;
    }

    yield put(configSlice.actions.setAutoJoin(true));
    yield put(configSlice.actions.setCreatedWithReload(true));
}
